import { css } from "@emotion/react";

type Props = {
  title: string;
};

const authorInfo = `1988年「どいつもこいつも」で第18回ちばてつや優秀新人賞(ヤング部門)を受賞し、以降エロチックなラブコメが人気の「すんドめ」「教科書にないッ！」などのヒットコミックを次々に発表。最新作「ぱンすと。」の最終刊となる15巻目が9月20日より発売中。`;

const Original: React.FC<Props> = ({ title }) => {
  return (
    <div id="original" css={mainStyle}>
      <div css={contentsWrapper}>
        <div css={upperTitleWrapperStyle}>
          <div css={borderStyle}></div>
          <div css={titleStyle}>{title}</div>
          <div css={borderStyle}></div>
        </div>
        <img
          src={
            process.env.REACT_APP_ASSET_BASE_PATH + "/img/original-top-txt.png"
          }
          css={topTxtImgStyle}
        />
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/gensaku.png"}
          css={[gensakuImgStyle, marginTopStyle(30, 15)]}
        />
        <div css={authorWrapperStyle}>
          <div css={subTitleStyle}>原作：岡田和人</div>
          <div css={[captionStyle, marginTopStyle(5)]}>{authorInfo}</div>
        </div>
        <a
          href="https://www.akitashoten.co.jp/series/2049"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={
              process.env.REACT_APP_ASSET_BASE_PATH + "/img/original-btn.png"
            }
            css={linkImgStyle}
          />
        </a>
      </div>
    </div>
  );
};

const contentsMaxWidth = 750;
const spSize = 768;

const mainStyle = css`
  width: 100%;
`;

const contentsWrapper = css`
  width: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;
const upperTitleWrapperStyle = css`
  width: 85%;
  max-width: 1125px;
  display: flex;
  align-items: center;
  padding: 30px;

  @media (max-width: ${spSize}px) {
    padding: 30px 20px 10px;
    padding-bottom: 10px !important;
  }
`;

const borderStyle = css`
  height: 3px;
  background-color: white;
  flex-grow: 1;
`;

const titleStyle = css`
  padding: 0 15px;
  font-family: MyFont;
  font-size: 18px;
  font-weight: 500;
  line-height: 100%;
`;

const topTxtImgStyle = css`
  width: 85%;
  max-width: ${contentsMaxWidth}px;
  height: auto;
`;

const gensakuImgStyle = css`
  width: 85%;
  max-width: 325px;
  height: auto;
`;

const linkImgStyle = css`
  margin-top: 30px;
  width: 275px;

  @media (max-width: ${spSize}px) {
    margin-top: 20px;
    width: 120px;
  }
`;

const marginTopStyle = (num: number, numSP?: number) => css`
  margin-top: ${num}px;

  @media (max-width: ${spSize}px) {
    margin-top: ${numSP ?? num}px;
  }
`;

const authorWrapperStyle = css`
  width: 85%;
  max-width: ${contentsMaxWidth}px;
  margin-top: 30px;
  text-align: left;

  @media (max-width: ${spSize}px) {
    margin-top: 15px;
  }
`;

const captionStyle = css`
  font-family: "Noto Sans JP", sans-serif;
  font-size: 14px;
  white-space: pre-wrap;
  font-weight: bold;

  @media (max-width: ${spSize}px) {
    font-size: 11px;
  }
`;

const subTitleStyle = css`
  font-family: "Noto Sans JP", sans-serif;
  font-size: 16px;
  white-space: pre-wrap;
  font-weight: bold;

  @media (max-width: ${spSize}px) {
    font-size: 13px;
  }
`;

export default Original;
